export default "__VITE_ASSET__D02q0k8R__"